import React from "react";
import "./Header.css"; // Assuming you have a separate CSS file for styling
import 'bootstrap/dist/css/bootstrap.min.css';
const Header = () => {
  const toggleMenu = () => {
    const menu = document.querySelector(".header-menu");
    const overlay = document.querySelector(".header-overlay");
    menu.classList.toggle("active");
    overlay.classList.toggle("active");
  };

 const showSubMenu = (event) => {
  const hasChildren = event.currentTarget; // Get the clicked <li> element
  const subMenu = hasChildren.querySelector(".header-menu-subs");
  if (subMenu) {
    subMenu.classList.add("active");
    subMenu.style.display='flex'
    subMenu.style.animation = "slideLeft 0.3s ease forwards";
  
    const menuTitle = hasChildren.querySelector("a").textContent;
    document.querySelector(".header-menu-mobile-title").textContent = menuTitle;
    document.querySelector(".header-menu-mobile-header").classList.add("active");
  }
};

  
  const hideSubMenu = () => {
    const subMenu = document.querySelector(".header-menu-subs.active");
    if (subMenu) {
      subMenu.style.animation = "slideRight 0.3s ease forwards";
      setTimeout(() => {
        subMenu.classList.remove("active");
      }, 300);
    }
    document.querySelector(".header-menu-mobile-title").textContent = "";
    document.querySelector(".header-menu-mobile-header").classList.remove("active");
  };
  

  return (
    <header className="header" id="myHeader">
      <div className="header-container">
        <div className="header-wrapper">
          <div className="header-item-left">
            <a href="/">
              <img
                src="https://tripta.in/frontend/img/Loding-logo.png"
                alt="header-logo"
                height="60"
              />
            </a>
          </div>
          <div className="header-item-center">
            <div className="header-overlay" onClick={toggleMenu}></div>
            <nav className="header-menu">
              <div className="header-menu-mobile-header">
                <button
                  type="button"
                  className="header-menu-mobile-arrow"
                  onClick={hideSubMenu}
                >
                  <i className="fas fa-arrow-left"></i>
                </button>
                <div className="header-menu-mobile-title"></div>
                <button
                  type="button"
                  className="header-menu-mobile-close"
                  onClick={toggleMenu}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <ul  className="header-menu-section">
                <li className="header-menu-item-has-children header-arrow" onClick={showSubMenu}>
                  <a href="#">Products<i style={{paddingLeft:'2px'}} class="fa-duotone fa-solid fa-angle-down"></i></a>
                  <div className="header-menu-subs header-menu-column-1">
                    <ul>
                      <li>
                        <a href="https://tripta.in/accounting-software">Features</a>
                      </li>
                      <li>
                        <a href="https://tripta.in/pricing#Pricing">Pricing</a>
                      </li>
                      <li>
                        <a href="https://tripta.in/pricing#WhyTripta">Why Tripta</a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="header-menu-item-has-children header-arrow " onClick={showSubMenu}>
                  <a href="#">Resource<i style={{paddingLeft:'2px'}} class="fa-duotone fa-solid fa-angle-down"></i></a>
                  <div className="header-menu-subs header-menu-column-1">
                    <ul>
                      <li className="header-menu-item-has-children header-arrow">
                        <a href="#">Product Manuals <i class="fa-duotone fa-solid fa-angle-down fa-rotate-270"></i></a>
                        <div className="header-menu-subs-subs header-menu-column-1">
                          <ul>
                            <li>
                              <a
                                href="https://tripta.in/Manual/Radix%20for%20Website/GettingHelp.html"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Radix 
                              </a>
                            </li>
                            <li>
                              <a
                                href="https://tripta.in/Manual/RELY%20for%20Website/GettingStarted.html"
                                target="_blank"
                                rel="noreferrer"
                              >
                                Rely
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="header-menu-item-has-children header-arrow" onClick={showSubMenu}>
                        <a href="#">FAQ <i class="fa-duotone fa-solid fa-angle-down fa-rotate-270"></i></a>
                        <div className="header-menu-subs-subs header-menu-column-1">
                          <ul>
                            <li>
                              <a href="https://tripta.in/radix-faq">Radix</a>
                            </li>
                            <li>
                              <a href="https://tripta.in/rely-faq">Rely</a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li>
                        <a href="https://tripta.in/blogs">Blogs</a>
                      </li>
                      <li>
                        <a href="https://tripta.in/download/TeamViewerQS_en-idcup63hyv.exe">
                          Download Remote Support
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
                <li style={{position:"static"}} className="header-menu-item-has-children header-arrow" onClick={showSubMenu}>
                  <a href="#">Company<i style={{paddingLeft:'2px'}} class="fa-duotone fa-solid fa-angle-down"></i></a>
                  <div id="company-menu-mega" className="header-menu-subs header-menu-mega header-menu-column-2" >
                    <div className="header-list-item">
                      <h4 className="header-title">
                        <img
                          src="https://tripta.in/frontend/images/Who%20we%20are.png"
                          alt=""
                          width="40"
                        />
                        Who we are
                      </h4>
                      <ul>
                        <li>
                          <a href="https://tripta.in/about">About Us</a>
                        </li>
                        <li>
                          <a href="https://tripta.in/contact_us">Contact Us</a>
                        </li>
                        <li>
                          <a href="https://payment.tripta.in/" target="_blank" rel="noreferrer">
                            Pay Now
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="header-list-item">
                      <h4 className="header-title">
                        <img
                          src="https://tripta.in/frontend/images/Join%20us.png"
                          alt=""
                          width="40"
                        />
                        &nbsp; Join Us
                      </h4>
                      <ul>
                        <li>
                          <a href="https://tripta.in/career">Careers</a>
                        </li>
                        <li>
                          <a href="https://tripta.in/life-tripta">Life @ Tripta</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li className="header-menu-item-has-children header-arrow">
                  <a href="https://tripta.in/tripta-partners">Partner</a>
                </li>
                <li className="header-call-icons">
                  <a className="header-call-icon" href="tel:+919723102310">
                    <img
                      className="header-i-call"
                      src="https://tripta.in/frontend/img/assets/Icon%20feather-phone-call.svg"
                      alt=""
                    />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
          <div className="header-item-right">
            <button
              type="button"
              className="header-menu-mobile-trigger"
              onClick={toggleMenu}
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
